export enum Country {
  Australia = 'au',
  NewZealand = 'nz',
}
